import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {BehaviorSubject, combineLatest, Observable, switchMap, tap} from 'rxjs';
import {FondsService} from '../../../services/fonds.service';
import {MatTableDataSource} from '@angular/material/table';
import {ISymbol} from '@lv1871/core';
import {firstNestedSymbolControl, ListControl} from '../../../models/uiArtefakt';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {ShellConfigService} from '../../../services/shell-config.service';
import {filter, map, take} from 'rxjs/operators';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {
  ModalDialogAnlaufmanagementComponent,
  ModalDialogAnlaufmanagementInput
} from '../modal-dialog/modal-dialog-anlaufmanagement/modal-dialog-anlaufmanagement.component';
import {FondsMitAnteil} from '../../../models/fondsMitAnteil';
import {UiUpdateService} from '../../../services/ui-update.service';
import {Fonds} from '../../../models/fonds';

@Component({
    selector: 'lv-anlaufmanagement',
    templateUrl: './anlaufmanagement.component.html',
    styleUrls: ['./anlaufmanagement.component.scss'],
    standalone: false
})
export class AnlaufmanagementComponent implements OnInit, AfterViewInit {
  public showInfotextCollapsable: boolean = false;
  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public dataSource: MatTableDataSource<FondsMitAnteil>;
  public selectedAnlaufFonds$: Observable<FondsMitAnteil>;
  private _uiArtefakt: ListControl;
  private _anlaufmanagementFondsliste$: BehaviorSubject<ListControl> = new BehaviorSubject<ListControl>(null);
  private _selectedFonds: FondsMitAnteil;

  constructor(public dialogRef: MatDialogRef<ModalDialogAnlaufmanagementInput>, private matDialog: MatDialog,
              private _fondsService: FondsService, private _uiUpdateService: UiUpdateService,
              private _shellConfigService: ShellConfigService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): ListControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: ListControl) {
    this._uiArtefakt = uiArtefakt;
    this._anlaufmanagementFondsliste$.next(uiArtefakt);
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  ngOnInit(): void {
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
    this.selectedAnlaufFonds$ = combineLatest<[Fonds[], ListControl]>([
      this._fondsService.getAllFonds(), this._anlaufmanagementFondsliste$]).pipe(
        map(([fonds, listControl]) => {
          const fondsMitAnteil = this._fondsService.getAnlaufAblaufmanagementFonds(fonds, listControl);
          this.dataSource = new MatTableDataSource([fondsMitAnteil]);
          this._selectedFonds = fondsMitAnteil;
          return fondsMitAnteil;
        }));
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  openAnlaufFonds() {
    const input= new ModalDialogAnlaufmanagementInput();
    input.selectedFonds = this._selectedFonds.fondsId;
    this._fondsService.getAnlaufmanagementFonds().pipe(
        take(1),
        switchMap(anlaufmanagementFonds => {
          input.anlaufFonds = anlaufmanagementFonds;
          return this.matDialog.open<ModalDialogAnlaufmanagementComponent,
              ModalDialogAnlaufmanagementInput, number>(ModalDialogAnlaufmanagementComponent, {
            data: input,
            width: '60%',
            disableClose: true,
            autoFocus: false
          }).afterClosed().pipe(
              filter(selectedFonds => !!selectedFonds),
              switchMap(selectedFonds => this._fondsService.getAllFonds().pipe(
                  tap(allFonds => {
                    const fondsFound = allFonds.filter(item => item.fondsId + '' === selectedFonds + '')[0] as FondsMitAnteil;
                    fondsFound.prozentualerAnteil = 100;
                    fondsFound.factsheet = this._fondsService.getLink('Factsheet', fondsFound.fondsId);
                    fondsFound.esgreport = this._fondsService.getLink('ESG-Report', fondsFound.fondsId);
                    this._selectedFonds = fondsFound;
                    this.dataSource = new MatTableDataSource([fondsFound]);
                  }),
                  tap(_ => {
                    this._fondsService.addAnlaufAblaufmanagementFonds(this._uiArtefakt, selectedFonds);
                    this._uiUpdateService.valueChangedSubject$.next(this._uiArtefakt);
                  }),
                  take(1)
              )));
        })
    ).subscribe();
  }
}
